import request from 'services/axios'

/** Everything in this log hangs off one fund. */
const base = (fundId: string) => `/messaging/history/moneypool/${fundId}`

/**
 * The fund's members and what each of them was told, one page at a time.
 *
 * `q` is left off the query string when empty rather than sent as `q=`, so the
 * unfiltered list is one URL and not two.
 */
export const getMessagingPeople = async (
    fundId: string,
    params: { sort: TMessagingPeopleSort; q?: string; page: number }
) => {
    const { data } = await request.get<IMessagingPeopleResponse>(
        `${base(fundId)}/people/`,
        {
            params: {
                sort: params.sort,
                page: params.page,
                ...(params.q ? { q: params.q } : {}),
            },
        }
    )
    return data
}

/** One member's timeline, newest first. */
export const getMessagingPersonMessages = async (
    fundId: string,
    memberId: string,
    page: number
) => {
    const { data } = await request.get<IMessagingPersonResponse>(
        `${base(fundId)}/people/${memberId}/`,
        { params: { page } }
    )
    return data
}

/** The same log read by event — one row per thing that happened. */
export const getMessagingEvents = async (
    fundId: string,
    params: { kind?: string; page: number }
) => {
    const { data } = await request.get<IMessagingEventsResponse>(
        `${base(fundId)}/events/`,
        {
            params: {
                page: params.page,
                ...(params.kind ? { kind: params.kind } : {}),
            },
        }
    )
    return data
}

/** One event: its header, plus who received it. */
export const getMessagingEvent = async (
    fundId: string,
    eventId: string,
    page: number
) => {
    const { data } = await request.get<IMessagingEventResponse>(
        `${base(fundId)}/events/${eventId}/`,
        { params: { page } }
    )
    return data
}
